import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {DetailInventaireComponent} from "../../inventaire/detail-inventaire/detail-inventaire.component";

@Component({
  selector: 'app-bontransfert-table',
  templateUrl: './bontransfert-table.component.html',
  styleUrls: ['./bontransfert-table.component.scss']
})
export class BontransfertTableComponent implements OnInit {

    @ViewChild('detailInventaire') detailInventaireComponent!: DetailInventaireComponent;
    @Input() status!:  'Crée' | 'En cours' | 'brouillon' | 'Annulé'|'Transféré';
    searchText = '';
    currentPage = 1;
    perPage = 5;
    pageOptions = [5, 10, 20];
    searchTerm = '';
    items  = [
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'En cours'
        },
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Transféré'
        }
    ];


    selectedStatus: string = 'Tous';
    //filteredItems: any[] = [];
    showFilter = false;
    filters = {
        client: '',
        projet: '',
        montant: '',
        etat: '',
        point_vente: ''
    };

    AddBonTransf() {
        this.router.navigate(['/bon-transfert/ajout-bonTransfert']);
    }
    toggleFilter() {
        this.showFilter = !this.showFilter;
      //  setTimeout(() => feather.replace());
    }
    constructor(private router : Router) { }

    ngOnInit(): void {

    }
    onSearch() {
        this.filteredItems;
    }
    onClick() {
        this.router.navigate(['/inventaire/ajout-inventaire']);
    }
    get filteredItems() {

        return this.items
            .filter(item => !this.status || item.status === this.status) // if no status → keep all

            .filter(item =>
                !this.searchText ||
                item.clientName.toLowerCase().includes(this.searchText.toLowerCase()) ||
                item.reference.toLowerCase().includes(this.searchText.toLowerCase())
            );

    }



    openDetailModal(item?: any) {
        this.detailInventaireComponent.openModal(item?.id);
    }
    getStatusClass(status: string): string {
        switch (status.toLowerCase()) {
            case 'crée':
                return 'cree';
            case 'annulé':
                return 'annule';
            case 'Transféré':
                return 'transfere';
            case 'En cours':
                return 'encours';
            default:
                return '';
        }
    }


}
